
import React from 'react';
import MainLayout from '@/components/layout/MainLayout';
import { DashboardHeader } from '@/components/dashboard/DashboardHeader';
import { StatCards } from '@/components/dashboard/StatCards';
import { RegionChart } from '@/components/dashboard/RegionChart';
import { CategoryDistribution } from '@/components/dashboard/CategoryDistribution';
import { ResponseRateChart } from '@/components/dashboard/ResponseRateChart';
import { LocalityDistribution } from '@/components/dashboard/LocalityDistribution';
import { EstablishmentNotifications } from '@/components/dashboard/EstablishmentNotifications';

const Dashboard = () => {
  return (
    <MainLayout>
      <div className="space-y-6">
        <DashboardHeader />


        <EstablishmentNotifications />
        <StatCards />
        
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <CategoryDistribution />
          <RegionChart />
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <ResponseRateChart />
          <LocalityDistribution />
        </div>
        

      </div>
    </MainLayout>
  );
};

export default Dashboard;
